import React from "react";
import "./Navbar.css";  

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-logo">Inicio</div>

      <div className="navbar-links">
        <a href="#propuestas">Propuestas</a>
        <a href="#contacto">Contacto</a>
        <a href="#sumate" className="navbar-btn">
          SUMATE
        </a>
      </div>
    </nav>
  );
}